/**
 * External Imports
 */
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Hook calls to fetch and store data in respective contexts
 */
export const useAppAuthorizedUser = () =>
  useAppSelector(state => state.AuthorizedUser);
export const useAppUser = () =>
  useAppSelector(state => state.AuthorizedUser.authorizedUser);
export const useAppFeatures = () =>
  useAppSelector(state => state.FeatureReducer);
